module.exports = __webpack_public_path__ + "img/feixinjiaju1.3a9fd16e.jpg";